import { createStyles, makeStyles } from '@material-ui/core';
var useStyles = makeStyles(function () {
    return createStyles({
        boton: {
            display: 'flex',
            backgroundColor: 'transparent',
            border: 'transparent',
        },
        iconoOjo: {
            cursor: 'pointer',
            '--icon-primary-dark': 'var(--gris-l43)',
        },
    });
});
export default useStyles;
